import { Typography } from '@mui/material';
import { action, computed, makeObservable, observable, runInAction } from 'mobx';
import { inject, observer } from 'mobx-react';
import ReactComponent from '../ReactComponent';
import PainelProcesso from './PainelProcesso';
import DetalhePregao from './DetalhePregao';

class ListaProcessos extends ReactComponent {
    scrollRoot;

    constructor(props) {
        super(props);

        makeObservable(this, {
            scrollRoot: observable,
            processos: computed,
            quantidadeTotalProcessos: computed,
            handleScroll: action,
            divListaProcessos: computed,
            renderProcessos: computed
        });
    }

    get processos() {
        return this.observableProps.processos;
    }

    get quantidadeTotalProcessos() {
        return this.processos && this.processos.length ? this.processos.length : 0;
    }

    handleScroll = () => {
        if (this.divListaProcessos && this.divFerramentasListaProcessos) {
            this.store.offsetScroll[this.observableProps.idListaProcessos] =
                this.divListaProcessos?.getBoundingClientRect()?.top -
                this.divFerramentasListaProcessos?.getBoundingClientRect()?.top;
            if (this.store.processoScroll) {
                this.store.processoScroll = undefined;
            }
        }
    };

    get divListaProcessos() {
        let idDivListaProcessos = 'listaProcessos' + this.observableProps.idListaProcessos;
        return document.getElementById(idDivListaProcessos);
    }

    get divFerramentasListaProcessos() {
        return document.getElementById('divFerramentasListaProcessos');
    }

    componentDidMount() {
        runInAction(
            () =>
                (this.scrollRoot = document.getElementById(
                    'scrollListaProcessos' + this.observableProps.idListaProcessos
                ))
        );
    }

    render() {
        return (
            <div
                id={'scrollListaProcessos' + this.observableProps.idListaProcessos}
                onScroll={this.handleScroll}
                style={{
                    flexGrow: 1,
                    overflowY: 'auto',
                    display:
                        this.observableProps.idListaProcessos === this.store.idProcessosEmExibicao ? 'grid' : 'none'
                }}
            >
                {this.renderProcessos}
            </div>
        );
    }

    isProcessoIgual(registro1, registro2) {
        return (
            registro1 &&
            registro2 &&
            registro1.processo.numeroCompleto.indexOf(registro2.processo.numeroCompleto) !== -1
        );
    }

    isProcessoApregoado(registro) {
        return this.isProcessoIgual(registro, this.sessaoStore.processoApregoado);
    }

    isProcessoExpandido(registro) {
        return this.isProcessoIgual(registro, this.store.processoExpandido);
    }

    get renderProcessos() {
        return this.processos && this.processos.length > 0 ? (
            <div
                id={'listaProcessos' + this.observableProps.idListaProcessos}
                style={{ display: 'flex', flexDirection: 'column', maxHeight: '400px', width: '100%' }}
            >
                <DetalhePregao />
                {this.processos.map((registro) => (
                    <PainelProcesso
                        key={'PP' + registro.processo.numeroCompleto}
                        registro={registro}
                        idListaProcessos={this.observableProps.idListaProcessos}
                        idProcessosEmExibicao={this.store.idProcessosEmExibicao}
                        isPreSessao={this.routerStore.isPreSessao}
                        scrollRoot={this.scrollRoot}
                        isProcessoApregoado={this.isProcessoApregoado(registro)}
                        isProcessoExpandido={this.isProcessoExpandido(registro)}
                    />
                ))}
            </div>
        ) : (
            <Typography
                variant="h6"
                style={{ margin: '20px' }}
            >
                {'Não há processos ' +
                    this.store.descricaoProcessosEmExibicao +
                    (this.store.existeFiltroAtivo ? ' que satisfaçam os critérios de filtro' : '')}
            </Typography>
        );
    }
}

export default inject('stores')(observer(ListaProcessos));
